import { Paragraph } from "@tvg/design-system";
import React, { memo } from "react";
import { formatPurse } from "@tvg/formatter/currency";
import { buildQaLabel } from "@tvg/test-utils/utils";
import { useSelector } from "react-redux";
import { getBalance } from "@urp/store-selectors/users";
import { Props } from "./types";
import { BALANCE, TEXT } from "../../constants";

const BalanceItem = ({ textColor, qaLabel = "" }: Props) => {
  const balance = useSelector(getBalance);

  return (
    <Paragraph
      qaLabel={buildQaLabel([qaLabel, BALANCE, TEXT])}
      color={textColor}
      lineHeight="125%"
      fontFamily="regular"
    >
      {formatPurse(balance)}
    </Paragraph>
  );
};

export default memo(BalanceItem);
